import { lazy } from "react";
import { Outlet, RouteObject } from "react-router-dom";
import LoggedInRoute from "ui/auth/containers/LoggedInRoute/LoggedInRoute";
import PartnerDetailsPage from "ui/partners/pages/PartnerDetailsPage/PartnerDetailsPage";
import ProgramDetailsPage from "ui/programs/pages/ProgramDetailsPage/ProgramDetailsPage";
import MainLayout from "../components/layout/MainLayout/MainLayout";
import { MainRoutes } from "./MainRouter.types";
import { useTransactionsRoutes } from "../../transactions/router/TransactionsRouter";
import TermsAndConditionsRoute from "ui/auth/containers/TermsAndConditionsRoute/TermsAndConditionsRoute";
import SendAndReceivePage from "ui/transactions/pages/SendAndReceivePage/SendAndReceivePage";

const HomePage = lazy(() => import("ui/common/pages/HomePage/HomePage"));
const ProgramsPage = lazy(() => import("../../programs/pages/ProgramsPage/ProgramsPage"));
const ReedemPage = lazy(() => import("../../redeem/pages/ReedemPage/ReedemPage"));
const ProfilePage = lazy(() => import("ui/user/pages/ProfilePage"));
const GiftCardPage = lazy(() => import("ui/common/pages/GiftCardPage/GiftCardPage"));
const GiftCardDetail = lazy(() => import("ui/giftcards/containers/view/GiftCardsDetail"));
const GiftCardPay = lazy(() => import("ui/giftcards/containers/pay/GiftCardPay"));
const GiftCardsPurchased = lazy(() => import("ui/giftcards/containers/purchased/GiftCardsPurchased"));
const SendOTPCodeVerificationPage = lazy(() => import("ui/transactions/pages/SendOTPCodeVerificationPage/SendOTPCodeVerificationPage"));

export const useMainRoutes = (): RouteObject[] => {
    const txRoutes = useTransactionsRoutes();
    return [
        {
            path: MainRoutes.MAIN,
            element: (
                <LoggedInRoute>
                    <TermsAndConditionsRoute>
                        <MainLayout>
                            <Outlet />
                        </MainLayout>
                    </TermsAndConditionsRoute>
                </LoggedInRoute>
            ),
            children: [
                {
                    path: MainRoutes.MAIN,
                    element: <HomePage />,
                },
                {
                    path: MainRoutes.PROGRAMS,
                    element: <ProgramsPage />,
                },
                {
                    path: MainRoutes.PROGRAM_DETAILS,
                    element: <ProgramDetailsPage />,
                },
                {
                    path: MainRoutes.REDEEM,
                    element: <ReedemPage />,
                },
                {
                    path: MainRoutes.SEND_AND_RECEIVE,
                    element: <SendAndReceivePage />,
                },
                {
                    path: MainRoutes.PARTNER_DETAILS,
                    element: <PartnerDetailsPage />,
                },
                {
                    path: MainRoutes.PROFILE,
                    element: <ProfilePage />,
                },
                {
                    path: MainRoutes.GIFT_CARDS,
                    element: <GiftCardPage />,
                },
                {
                    path: MainRoutes.GIFT_CARDS_DETAILS,
                    element: <GiftCardDetail />,
                },
                {
                    path: MainRoutes.GIFT_CARDS_REDEEM,
                    element: <GiftCardPay />,
                },
                {
                    path: MainRoutes.GIFT_CARDS_PURCHASED,
                    element: <GiftCardsPurchased />,
                },
                {
                    path: MainRoutes.SEND_OTP_CODE_VERIFICATION,
                    element: <SendOTPCodeVerificationPage giftCard={true} />,
                },
                ...txRoutes,
            ],
        },
    ];
};
